import React from 'react';
import { Helmet } from 'react-helmet';
import {backendHost,url as domainURL} from '../api-config';

const CSPHelper = (props) => {

  return (
    <div>
      <Helmet>
        <meta http-equiv="Content-Security-Policy" content={`frame-src 
        'self' 
        https://${window.axa.oidc?.mol?.aad_instance}
        https://${window.axa.oidc?.hol?.aad_instance}
        https://${(window.axa.liveAgentMIAW?.mol.eswJsPath)?.split("/")[2]}
        https://${(window.axa.liveAgentMIAW?.hol.eswJsPath)?.split("/")[2]}
        https://sgtm.axahealth.co.uk/
        https://8888868.fls.doubleclick.net
        https://*.digital-cloud.medallia.eu
        https://www.googletagmanager.com
        https://a24684600044.cdn.optimizely.com 
        https://a24684600044.cdn-pci.optimizely.com;

        script-src 
        'strict-dynamic'
        'unsafe-eval'
        nonce-${props.nonceValue}
        'self'
        http://cdn.optimizely.com/js/24684600044.js
        https://sgtm.axahealth.co.uk
        https://www.googletagmanager.com
        https://*.googletagmanager.com
        https://*.optimizely.com
        https://collection.decibelinsight.net
        https://*.decibelinsight.net
        wss://collection.decibelinsight.net
        https://optimizely.s3.amazonaws.com
        https://www.google-analytics.com
        https://tagmanager.google.com
        https://cdn-assets-prod.s3.amazonaws.com
        ${window.axa.liveAgentMIAW?.mol.eswJsPath}
        ${window.axa.liveAgentMIAW?.hol.eswJsPath}
        ${domainURL}
        https://c.evidon.com;
      
        connect-src 
        'self'
        https://logx.optimizely.com
        https://*.optimizely.com
        https://c.evidon.com/dg/6650/companyConfig.json
        https://sgtm.axahealth.co.uk/g/collect
        https://sgtm.axahealth.co.uk
        https://px.ads.linkedin.com/wa/
        https://px.ads.linkedin.com
        https://${window.axa.oidc?.mol?.aad_instance}
        wss://collection.decibelinsight.net
        https://dgcollector.evidon.com
        https://collection.decibelinsight.net
        https://*.decibelinsight.net
        https://analytics-fe.digital-cloud.medallia.eu
        https://resources.digital-cloud.medallia.eu
        https://*.digital-cloud.medallia.eu
        https://stats.g.doubleclick.net
        https://*.kampyle.com
        https://*.evidon.com
        https://js.monitor.azure.com
        www.google.com
        https://${window.axa.oidc?.hol?.aad_instance}
        ${window.axa.liveAgentMIAW?.mol.scrt2URL}
        ${window.axa.liveAgentMIAW?.hol.scrt2URL}
        ${window.axa.liveAgentMIAW?.mol.ESWMSGOnlineServicing}
        ${window.axa.liveAgentMIAW?.hol.ESWMSGOnlineServicing}
        ${backendHost}
        ${domainURL}
        https://www.googletagmanager.com
        https://*.google-analytics.com https://*.analytics.google.com https://*.googletagmanager.com
        https://c.evidon.com/geo/country.js
        https://dc.services.visualstudio.com/v2/track
        https://dc.services.visualstudio.com
        https://c.evidon.com;
      
        img-src * 'self' data: https: https://cdn.optimizely.com https://*.google-analytics.com https://*.googletagmanager.com
        https://app.optimizely.com
        https://*.optimizely.com
        https://sgtm.axahealth.co.uk
        https://*.axahealth.co.uk
        https://www.googletagmanager.com
        https://www.google-analytics.com
        https://ssl.gstatic.com/ data:
        https://*.kampyle.com
        https://*.evidon.com
        www.google.com
        www.google.co.uk
        ${domainURL};

        style-src 
        'strict-dynamic'
        nonce-${props.nonceValue}
        'unsafe-inline'
        'self'
        https://*.kampyle.com
        https://service.force.com
        ${window.axa.liveAgentMIAW?.mol.ESWMSGOnlineServicing}/assets/styles/bootstrap.min.css
        ${window.axa.liveAgentMIAW?.hol.ESWMSGOnlineServicing}/assets/styles/bootstrap.min.css
        https://*.google-analytics.com
        https://*.googletagmanager.com
        https://fonts.googleapis.com/css 
        https://www.google-analytics.com 
        https://tagmanager.google.com
        https://www.googletagmanager.com;`}
        />
      </Helmet>
    </div>
  );
};

export default CSPHelper;
